const getImageUrls = product => {
  if (product.imageUrls && product.imageUrls.length > 0) {
    return product.imageUrls.slice();
  }
  return [product.imageUrl];
};

export default getImageUrls;
